import {
    Box,
    Stack,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr
} from "@chakra-ui/react";
import React from "react";
import { AccountAvatar } from "../../components/AccountAvatar";
import { useAllWaitingQueueQuery } from "../../graphql";
import { formatDateTime } from "../../utils";

export const AllWaitingQueue: React.FC = () => {
    const { loading, data } = useAllWaitingQueueQuery({
        fetchPolicy: "network-only",
        pollInterval: 10 * 1000
    });

    if (!data?.allWaitingQueue?.length) {
        return <Text>Nuk ka asnjë telefonatë aktive apo në pritje!</Text>;
    }

    return (
        <Text>
            { data?.allWaitingQueue.map((queue) => {
                return (
                    <Box
                        borderWidth="1px"
                        borderRadius="lg"
                        background="#FFF"
                        padding="15px"
                        key={ queue.profile.id }
                        marginBottom="20px"
                    >
                        <AccountAvatar account={ queue.profile.account } />

                        { queue.calls.length ? (
                            <Table
                                variant="striped"
                                size="sm"
                                key={ queue.profile.id }
                                marginTop="15px"
                            >
                                <Thead>
                                    <Tr>
                                        <Th>Telefonuesi</Th>
                                        <Th isNumeric>Kërkimi i telefonatës</Th>
                                        <Th isNumeric>Fillimi i telefonatës</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    { queue.calls.map((call) => (
                                        <Tr key={ call.id }>
                                            <Td>
                                                <Stack direction="row">
                                                    { call.participants
                                                        .filter(
                                                            (p) => p.account.id !== queue.profile.account.id
                                                        )
                                                        .map((participant) => (
                                                            <AccountAvatar
                                                                key={ participant.account.id }
                                                                account={ participant.account }
                                                                size="xs"
                                                                role={ false }
                                                            />
                                                        )) }
                                                </Stack>
                                            </Td>
                                            <Td isNumeric>{ formatDateTime(call.requestTime) }</Td>
                                            <Td isNumeric>
                                                { call.startTime ? formatDateTime(call.startTime) : "-" }
                                            </Td>
                                        </Tr>
                                    )) }
                                </Tbody>
                            </Table>
                        ) : null }
                    </Box>
                );
            }) }
        </Text>
    );
};
